module.exports = __webpack_public_path__ + "static/media/foto_login_2_1.80ef64c5.jpg";